// Vanilla reimplementation of Bootstrap 4's declarative collapse API (data-toggle="collapse").
// Drives the mobile nav hamburger toggle in header.twig (.navbar-toggler -> #siteHeaderCollapse) —
// existing .collapse markup and CSS (static/src/lib/bootstrap.css) are unchanged, only the JS
// engine is replaced.

document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-toggle="collapse"]');
    if (!trigger) return;

    event.preventDefault();

    const targetSelector = trigger.getAttribute('data-target');
    const target = targetSelector ? document.querySelector(targetSelector) : null;
    if (!target) return;

    const isOpen = target.classList.toggle('show');
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
});
